// src/components/empleado/GoogleMapsEmpleado.js
const GOOGLE_MAPS_ID = 'googleMapsScript_Empleado';
const API_KEY = 'AIzaSyAZNnAAUdLjXR2GGOkyBABC1ch4_o38i2U'; // Tu llave encontrada

const SRC = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`;

export const loadGoogleMapsEmpleado = (callback) => {
    if (window.google && window.google.maps) {
        if (callback) callback();
        return;
    }
    const existingScript = document.getElementById(GOOGLE_MAPS_ID);
    if (existingScript) {
        existingScript.addEventListener('load', () => { if (callback) callback(); });
        return;
    }
    const script = document.createElement('script');
    script.src = SRC;
    script.id = GOOGLE_MAPS_ID;
    script.async = true;
    script.defer = true;
    script.onload = () => { if (callback) callback(); };
    document.body.appendChild(script);
};